<template>
    <ThemeSwitcher />
    <div class="card">
        <Chart type="bar" :data="chartData" :options="chartOptions" />
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Chart from "primevue/chart";
//import api from "@/utils/axios";


onMounted(async() => {
    //chartData.value = setChartData();
    //chartOptions.value = setChartOptions();
    chartOptions.value = setChartOptions();
    await getSalesData();
});

const chartData = ref(null);
const chartOptions = ref(null);

const getSalesData = async () => {
    try {
        //const response = await api.get('/report/weeklysalesreport');
        //console.log(response);
        //const rawData = response.data;
        //console.log('28');
        //console.log(rawData);
        //const labels = rawData.map(item => item.Weekly )
        //const spentValues = rawData.map(item => Math.round(item.sales_total));

        chartData.value = {
                labels: [20,21,22,23],
                datasets: [
                    {
                        label: [20,21,22,23],
                        data: [1500,2000,2500,3000],
                        backgroundColor: ['rgba(249, 115, 22, 0.2)', 'rgba(6, 182, 212, 0.2)', 'rgb(107, 114, 128, 0.2)'],
                        borderColor: ['rgb(249, 115, 22)', 'rgb(6, 182, 212)', 'rgb(107, 114, 128)', 'rgb(139, 92, 246)'],
                        borderWidth: 1
                    }
                ]
            };
    } catch (error){
        console.error("API 讀取失敗:", error);
    }
}

const setChartOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--p-text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
    const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

    return {
        plugins: {
            legend: {
                display: false,
            },
                title: {
                    display: true,
                    text: 'Weekly Sales',
                    color: textColor,
                    font: {
                        size: 16,         
                        weight: 'bold',   
                        family: 'Arial'   
                    } 
                }
            },
        scales: {
            x: {
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder
                }
            },
            y: {
                beginAtZero: true,
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder
                }
            }
        }
    };
}
</script>